export default {
  nav: {
    main: 'Glavna',
    ordersAndInvoices: 'Naročila in računi',
    drafts: 'Osnutki',
    automation: 'Avtomatizacija',
    workspace: 'Delovno okolje',
    templates: 'Predloge',
    delivery: 'Dostava',
    settings: 'Nastavitve',
    shippingLabels: 'Nalepke za pošiljanje',
    subscriptions: 'Naročnine',
    support: 'Podpora',
    developer: 'Razvijalec',
    writeReview: 'Napišite oceno',
    supportTicket: 'Zahtevek za podporo',
    welcomeTour: 'Uvodni ogled',
    administratorConsole: 'Skrbniška konzola',
    logout: 'Odjava',
  },
  dashboard: {
    pageTitle: 'Naročila in računi',
    pageDescription: 'Manage your orders and invoices',
    title: 'Naročila in računi',
    selectedOrders: '{count} izbranih naročil',
    completed: '% dokončano',
    processing: 'Obdelava, prosimo počakajte...',
    bulkDownload: 'Skupinski prenos',
    upgradeBulkDownload: 'Nadgradite svoj paket za skupinski prenos',
    showFilters: 'Prikaži filtre',
    hideFilters: 'Skrij filtre',
    creatingInvoices: 'Ustvarjanje računov, prosimo počakajte...',
    bulkCreateInvoices: 'Skupinsko ustvarjanje računov',
    cannotCreateAutopilot: 'Računov ne morete ustvariti ročno, ko je način izdajanja na samodejnem pilotu.',
    exportInvoices: 'Izvozi račune ali naročila',
    capturePayments: 'Ročno zajemi plačila',
    filterOrders: 'Filtriraj naročila',
    error: 'Ojoj, nekaj je šlo narobe...',
    close: 'Zapri',
    chooseDate: 'Izberite datum',
    chooseIssueDate: 'Izberite datum izdaje za izbrane račune',
    cancel: 'Prekliči',
    createInvoices: 'Ustvari račune',
    storno: 'Storno',
    bulkOrderCapture: 'Skupinski zajem naročil',
  },
  search: {
    createdBetween: 'Ustvarjeno med',
    modifiedBetween: 'Spremenjeno med',
    orderNumber: 'Naročilo #',
    invoiceNumber: 'Račun #',
    refundNumber: 'Vračilo #',
    customer: 'Stranka',
    payment: 'Plačilo',
    any: 'Katerokoli',
    authorized: 'Avtorizirano',
    pending: 'V čakanju',
    paid: 'Plačano',
    partiallyPaid: 'Delno plačano',
    refunded: 'Vrnjeno',
    voided: 'Razveljavljeno',
    partiallyRefunded: 'Delno vrnjeno',
    unpaid: 'Neplačano',
    fulfillment: 'Izpolnitev',
    fulfilled: 'Poslano',
    partial: 'Delno',
    unfulfilled: 'Neposlano',
    loading: 'Nalaganje naročil...',
    search: 'Iskanje',
  },
  orderList: {
    noCustomer: 'Brez stranke',
    downloadOrder: 'Prenesi naročilo',
    deleteWarning: 'Pomembno! To bo izbrisalo vse račune in vračila, ustvarjena po datumu:',
    includingInvoice: 'vključno z izbranim računom #',
    pressOk: 'Pritisnite V redu za nadaljevanje ali Prekliči za prekinitev.',
    cannotCreateAutopilot: 'Računov ne morete ustvariti ročno, ko je način izdajanja na samodejnem pilotu.',
    createInvoice: 'Ustvari račun za to naročilo',
    create: 'Ustvari',
    addCreditNote: 'Dodaj dobropis',
    createStorno: 'Ustvari storno račun',
    refund: 'Vračilo',
    downloadInvoice: 'Prenesi ta račun',
    download: 'Prenesi',
    default: 'Privzeto',
    downloadStorno: 'Prenesi ta storno/dobropis',
    fulfillOrder: 'Izpolni naročilo',
    orderNum: 'Naročilo #',
    locPrefix: 'Predpona lokacije',
    invoiceNum: 'Račun #',
    refundNum: 'Vračilo #',
    customerCol: 'Stranka',
    orderCreatedDate: 'Datum ustvarjanja naročila',
    orderModifiedDate: 'Datum spremembe naročila',
    delivered: 'Dostavljeno',
    paymentStatus: 'Status plačila',
    fulfillmentStatus: 'Status pošiljke',
    totalOutstanding: 'Skupni neporavnani znesek',
    originalPrice: 'Prvotna cena',
    noOrders: 'Vaša trgovina nima naročil za izbrani status.',
    cannotCreateNoOrders: 'Računov ni mogoče ustvariti, ko ni naročil.',
    createOrdersFirst: 'Prosimo, ustvarite vsaj eno naročilo in poskusite znova.',
    createOrders: 'Ustvari naročila',
    loadingOrders: 'Nalaganje...',
    paidManual: 'Plačano - Ročno',
    paid: 'Plačano',
    refunded: 'Vrnjeno',
    pending: 'V čakanju',
    partiallyPaid: 'Delno plačano',
    partiallyRefunded: 'Delno vrnjeno',
    fulfilled: 'Poslano',
    unfulfilled: 'Neposlano',
    deliveryPending: 'V čakanju',
    deliverNow: 'Dostavi zdaj',
    deliveryPartial: 'Delna',
    notDelivered: 'Ni dostavljeno',
    deliverAgain: 'Dostavi znova',
    deliveryDetails: 'Podrobnosti dostave',
    deliveryFailed: 'Dostava neuspešna',
    sent: 'Poslano',
    failed: 'Neuspelo',
    toLabel: 'Za',
    folderLabel: 'Mapa',
    open: 'Odprto',
    invoice: 'Račun',
    creditNote: 'Dobropis',
    stornoLabel: 'Storno',
    unknown: 'Neznano',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablica strank',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-pošta',
    ftpChannel: 'FTP',
    revertToDate: 'Povrni na ta datum',
    add: 'Dodaj',
    close: 'Zapri',
  },
  downloadDialog: {
    downloadType: 'Prenesi {type}...',
    selectTemplate: 'Izberite predlogo iz galerije za izvoz naročil, računov, storno računov ali dobropisov.',
    getMoreTemplates: 'Pridobi več predlog',
    createNewTemplate: 'Ustvari novo predlogo',
    allCreatedBetween: 'Vsi ustvarjeni {type} med',
    selectedType: 'Izbrani {type}',
    and: 'in',
    status: 'Status',
    any: 'Katerikoli',
    open: 'Odprt',
    closed: 'Zaprt',
    cancelled: 'Preklican',
    paymentStatus: 'Status plačila',
    fulfillmentStatus: 'Status pošiljke',
    fulfilled: 'Poslano',
    partial: 'Delno',
    unfulfilled: 'Neposlano',
    authorized: 'Avtorizirano',
    pending: 'V čakanju',
    paid: 'Plačano',
    partiallyPaid: 'Delno plačano',
    refunded: 'Vrnjeno',
    voided: 'Razveljavljeno',
    partiallyRefunded: 'Delno vrnjeno',
    unpaid: 'Neplačano',
    format: 'Format',
    forLocation: 'Za lokacijo',
    advancedOptions: 'Napredne možnosti',
    exportHSCodes: 'Izvozi HS kode zalog (počasnejše)',
    noteChrome: 'Opomba: Za optimalen prenos je priporočen Chrome in onemogočen blokator oglasov.',
    downloadIndividually: 'Prenesi posamezno',
    downloadGrouped: 'Prenesi skupinsko',
  },
  templates: {
    pageTitle: 'Predloge',
    pageDescription: 'Customize your invoice templates',
    title: 'Predloge',
    installTranslated: 'Namesti prevedeno predlogo',
    installTranslatedDesc: 'Izberite drug jezik s klikom na ta gumb.',
    createNew: 'Po potrebi ustvarite novo predlogo',
    createNewDesc: 'Kliknite na ta gumb, da po potrebi ustvarite novo predlogo.',
    customize: 'Prilagodi predloge',
    customizeDesc: 'Kliknite na privzeto predlogo, da jo prilagodite. Spremenite lahko logotip, barve in za naprednejše uporabnike tudi kodo v ozadju.',
    defaultTemplate: 'Račun, storno in dobropis (privzeto)',
    logo: 'Logotip',
    colorPalette: 'Barvna paleta',
    getColorPalettes: 'Pridobi barvne palete',
    paperSize: 'Velikost papirja',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Usmerjenost',
    landscape: 'Ležeče',
    portrait: 'Pokončno',
    margin: 'Rob (cm)',
    unsavedChanges: 'Neshranjene spremembe',
    discard: 'Zavrzi',
    save: 'Shrani',
  },
  labels: {
    pageTitle: 'Nalepke za pošiljanje',
    pageDescription: 'Create and manage shipping labels',
    title: 'Nalepke za pošiljanje',
    glsRequiresPro: 'GLS nalepke za pošiljanje za EEU zahtevajo paket Professional.',
    upgradeDesc: 'Nadgradite na Professional za ustvarjanje in upravljanje nalepk za pošiljanje.',
    upgradePlan: 'Nadgradite svoj paket',
    eeuGls: 'EEU GLS',
    enabled: 'Omogočeno',
    country: 'Država',
    hungary: 'Madžarska',
    slovakia: 'Slovaška',
    czech: 'Češka',
    romania: 'Romunija',
    slovenia: 'Slovenija',
    croatia: 'Hrvaška',
    senderId: 'ID pošiljatelja',
    username: 'Uporabniško ime',
    password: 'Geslo',
    name: 'Ime',
    city: 'Mesto',
    address: 'Naslov',
    zipCode: 'Poštna številka',
    contactPerson: 'Kontaktna oseba',
    phone: 'Telefon',
    email: 'E-pošta',
    glsServices: 'GLS storitve',
    expressService: 'Ekspresna storitev',
    exchangeService: 'Storitev zamenjave',
    smsService: 'SMS storitev',
    smsText: 'SMS besedilo',
    preAdviceService: 'Storitev predhodnega obvestila',
    unsavedChanges: 'Neshranjene spremembe',
    discard: 'Zavrzi',
    save: 'Shrani',
  },
  billing: {
    pageTitle: 'Obračunavanje',
    pageDescription: 'Manage your subscription and billing',
    title: 'Obračunavanje',
    subscriptionFor: 'Naročniški paket za trgovino',
    currentlySubscribed: 'Trenutno ste naročeni na',
    plan: 'paket',
    cancelSubscription: 'Prekliči naročnino',
    upgradePlan: 'Nadgradite svoj paket',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / mesec',
    upgrade: 'Nadgradi',
    includesAllStarter: 'Vključuje vse funkcije paketa Starter ter:',
    proFeature1: 'Globalna skladnost: predpone glede na lokacijo in prilagojeno zaporedno številčenje',
    proFeature2: 'Pametna lokalizacija: samodejno prevedena e-pošta in lokalizirane PDF priloge',
    proFeature3: 'Celoten življenjski cikel B2B dokumentov: predračuni, B2B ponudbe in dobropisi',
    proFeature4: 'B2B računovodska sinhronizacija: natančnost na 3 decimalna mesta in prikaz v več valutah',
    proFeature5: 'Avtomatizirane varnostne kopije: samodejno kopirajte račune na varen FTP ali Google Drive',
    proFeature6: 'Shopify Flow: avtomatizirajte ustvarjanje, dostavo in storniranje računov prek sprožilcev in dejanj Flow',
    proFeature7: 'Napredna logika AI: uporabite AI na napravi za kompleksne pogojne postavitvene klavzule',
    proFeature8: 'Izvoz UBL XML & ZUGFeRD / Factur-X (skladnost z evropskim e-računovodstvom)',
    proFeature9: 'EPC QR kode za takojšnja mobilna POS plačila',
    proFeature10: 'GLS nalepke za pošiljanje za EEU',
    proFeature11: '7-letno hranjenje davčnih dokumentov za skladnost',
    currentlyUsing: 'Trenutno uporabljate naš',
    free: 'brezplačni',
    subscriptionPlan: 'naročniški paket.',
    monthlyUsage: 'Mesečna uporaba',
    monthlyGenerated: '{count} / 50 računov ta mesec',
    monthlyLimitReached: 'Mesečna omejitev dosežena. Nadgradite na Starter za neomejene račune.',
    freePlan: 'Brezplačni paket',
    freeToInstall: 'Brezplačna namestitev',
    freeFeature1: 'Do 50 računov/naročil na mesec',
    freeFeature2: 'Dostop do vseh 31+ vnaprej pripravljenih predlog',
    freeFeature3: 'Osnovni AI Copilot',
    freeFeature4: 'Standardni prenosi PDF in tiskanje',
    freeFeature5: 'Standardni nabor dokumentov (računi, dobavnice, potrdila)',
    freeFeature6: '3-mesečno varno hranjenje računov',
    starterPlan: 'Paket Starter',
    starterPrice: '$9.99 / mesec',
    starterPricePerInvoice: '+ 3¢ na ustvarjen račun',
    subscribe: 'Naroči se',
    starterFeature1: 'Neomejeni računi in naročila',
    starterFeature2: 'Avtomatizirana dostava PDF po e-pošti',
    starterFeature3: 'Poln dostop do hibridnega urejevalnika in AI Copilota',
    starterFeature4: 'Integracija Shopify POS in črtnih kod',
    starterFeature5: 'Shopify Flow: sprožilci in dejanja za avtomatizacijo računov',
    starterFeature6: 'Izvoz UBL XML / PEPPOL & ZUGFeRD / Factur-X (skladnost z e-računovodstvom)',
    starterFeature7: '1-letno varno hranjenje računov',
    proTaxOverrides: 'Prilagojene davčne preglasitve: DDV / GST po izdelku in stopnje na ravni SKU',
    unsavedChanges: 'Neshranjene spremembe',
    discard: 'Zavrzi',
    save: 'Shrani',
  },
  autopilot: {
    pageTitle: 'Avtomatizacija',
    pageDescription: 'Automate invoice creation and management',
    title: 'Avtomatizacija',
    autoCreate: 'Samodejno ustvari račune',
    disabled: 'Onemogočeno (ročno)',
    whenCreated: 'Ko so naročila ustvarjena',
    whenFulfilled: 'Ko so naročila izpolnjena',
    whenPaid: 'Ko so naročila plačana',
    autoCreateDesc: 'Računi bodo ustvarjeni na datum, ko so naročila ustvarjena, izpolnjena ali plačana.',
    autoStorno: 'Samodejno storniraj račune',
    whenCancelled: 'Ko so naročila preklicana ali vrnjena',
    autoStornoDesc: 'Storno računi bodo ustvarjeni na datum, ko so naročila razveljavljena/preklicana ali ko so ustvarjena vračila.',
    cannotAutoFree: 'Samodejno ustvarjanje računov ni mogoče z brezplačnim paketom.',
    upgradePlan: 'Nadgradite svoj paket',
    unsavedChanges: 'Neshranjene spremembe',
    discard: 'Zavrzi',
    save: 'Shrani',
  },
  delivery: {
    pageTitle: 'Dostava',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Dostava',
    settings: 'Nastavitve',
    useOrderNumbers: 'Uporabi številke naročil za datoteke',
    sendIfCountry: 'Pošlji, če je država naslova za račun',
    countryCodesHint: 'Navedite vse kode držav, ločene s podpičjem.',
    sendForTags: 'Pošlji za stranke, ki imajo eno od navedenih oznak',
    tagsHint: 'Navedite vse oznake, ločene s podpičjem.',
    emailDelivery: 'Dostava po e-pošti',
    sendAsPdf: 'Pošlji račune kot PDF priloge strankam',
    autoSend: 'Samodejno pošlji, ko je račun ustvarjen',
    subject: 'Zadeva',
    body: 'Vsebina',
    xmlAttachments: 'XML priloge',
    attachUbl: 'Priloži UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Priloži ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Pošlji testno e-pošto',
    sending: 'Pošiljanje...',
    customSmtp: 'Strežnik SMTP po meri',
    customSmtpDesc: 'Uporabite svoj poštni strežnik namesto privzetega',
    enableSmtp: 'Omogoči SMTP po meri',
    smtpHost: 'Gostitelj SMTP',
    port: 'Vrata',
    useSsl: 'Uporabi SSL/TLS',
    username: 'Uporabniško ime',
    password: 'Geslo',
    fromEmail: 'E-pošta pošiljatelja',
    fromName: 'Ime pošiljatelja',
    shopifyLiquid: 'Shopify Liquid predloga',
    pasteInto: 'Prilepite to v vašo',
    orderConfirmation: 'predlogo potrditve naročila',
    toAddLink: 'za dodajanje povezave za prenos.',
    downloadInvoice: 'Prenesite svoj račun',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Pošlji zahtevke na ClientsTablet ob ustvarjanju računov',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Pošlji PDF račune kot carinske dokumente na ShippyPro za države izven EU',
    ftpBackup: 'FTP/SFTP varnostna kopija',
    ftpDesc: 'Samodejno kopiraj račune na vaš strežnik',
    enableFtp: 'Omogoči samodejno FTP varnostno kopiranje',
    host: 'Gostitelj',
    useSftp: 'Uporabi SFTP (varno)',
    destinationFolder: 'Ciljna mapa',
    xmlFiles: 'XML datoteke',
    includeUbl: 'Vključi UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Vključi ZUGFeRD / Factur-X XML',
    testConnection: 'Preizkusi povezavo',
    testing: 'Preizkušanje...',
    pro: 'PRO',
    upgradeFtp: 'Nadgradite na Professional za samodejno kopiranje računov na vaš FTP/SFTP strežnik.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Samodejno sinhroniziraj račune na vaš Drive',
    connected: 'Povezano',
    disconnect: 'Prekini povezavo',
    notWorking: 'Ne deluje? Pojdite na',
    googlePermissions: 'Google dovoljenja',
    removeThenReconnect: 'odstranite Invoice Browse, nato ponovno povežite.',
    connectGoogleDrive: 'Poveži Google Drive',
    upgradeGoogleDrive: 'Nadgradite na Professional za samodejno sinhronizacijo računov na Google Drive.',
    unsavedChanges: 'Neshranjene spremembe',
    discard: 'Zavrzi',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Shrani',
  },
  bookkeeping: {
    pageTitle: 'Nastavitve',
    pageDescription: 'Configure your invoice settings',
    title: 'Nastavitve',
    owner: 'Lastnik',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Ohrani ločeno številčenje računov za vsako lokacijo naročila',
    keepDifferentNumberingDisabled: 'Ločeno številčenje računov za vsako lokacijo naročila ni možnost, ki je omogočena z vašim paketom.',
    locationEmailDesc: 'To vam omogoča pošiljanje e-pošte in računov, prevedenih glede na lokacijo naročila: lokacija inventarja, naslov za dostavo ali naslov za račun',
    upgradePlan: 'Nadgradite svoj paket',
    matchingCriteria: 'Kriteriji ujemanja',
    locationId: 'ID lokacije',
    shippingCountryCode: 'Koda države naslova za dostavo',
    billingCountryCode: 'Koda države naslova za račun',
    matchLocationDesc: 'Ujemanje lokacije na podlagi ID-ja lokacije naročila, kode države naslova za dostavo ali račun.',
    companyInfo: 'Podatki o podjetju',
    name: 'Ime',
    website: 'Spletna stran',
    registrationNumber: 'Matična številka',
    taxId: 'Davčna številka',
    addressSection: 'Naslov',
    streetName: 'Ime ulice',
    streetNumber: 'Hišna številka',
    zip: 'Poštna številka',
    city: 'Mesto',
    region: 'Regija',
    country: 'Država',
    bankingInfo: 'Bančni podatki',
    bankName: 'Ime banke',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Izdajanje računov',
    decimalPlaces: 'Decimalna mesta',
    invoicesPrefix: 'Predpona računov',
    currentInvoiceNumber: 'Trenutna številka računa',
    creditNotesPrefix: 'Predpona dobropisov',
    currentCreditNoteNumber: 'Trenutna številka dobropisa',
    lastInvoiceDate: 'Datum zadnjega računa',
    noInvoicesYet: 'Še ni ustvarjenih računov.',
    confirmReverting: 'Potrditev vrnitve sistema',
    allInvoicesAfter: 'Vsi računi in njihovi storni, izdani po',
    willBeRemoved: 'bodo odstranjeni. Ali želite nadaljevati z vrnitvijo sistema?',
    cancel: 'Prekliči',
    revert: 'Povrni',
    revertDesc: 'Vrnitev sistema bo izbrisala vse račune, ustvarjene po izbranem datumu.',
    revertToDate: 'Povrni na ta datum',
    reverting: 'Vračanje sistema, prosimo počakajte...',
    useOrderNumbering: 'Uporabi številčenje naročil',
    showVat: 'Prikaži DDV na računih',
    overrideTaxes: 'Preglasi davke',
    pricesIncludeTax: 'Cene vključujejo davek',
    productsTaxRate: 'Davčna stopnja za izdelke',
    shippingTaxRate: 'Davčna stopnja za dostavo',
    skusSeparated: 'SKU-ji ločeni s podpičjem',
    skusTaxRate: 'Davčna stopnja za SKU-je',
    useOrderDates: 'Uporabi datume ustvarjanja naročil za račune',
    convertCurrency: 'Pretvori cene v valuto, v kateri stranka plačuje',
    unsavedChanges: 'Neshranjene spremembe',
    discard: 'Zavrzi',
    save: 'Shrani',
  },
  drafts: {
    pageTitle: 'Osnutki',
    pageDescription: 'Manage your draft orders',
    title: 'Osnutki',
    download: 'Prenesi',
    newDraft: 'Nov osnutek',
    exporting: 'Izvažanje {status}%...',
    accessNotGranted: 'Dostop do osnutkov naročil ni odobren. Prosimo',
    reLogin: 'prijavite se znova',
    toGrantPermissions: 'za odobritev zahtevanih dovoljenj "Osnutki naročil".',
    pushFailed: 'Pošiljanje na Shopify ni uspelo:',
    exportError: 'Napaka pri izvozu:',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati ta osnutek?',
    incompleteCustomer: 'Podatki o stranki so nepopolni:',
    pushWithoutCustomer: 'Osnutek bo poslan na Shopify brez podatkov o stranki. Ali želite nadaljevati?',
    customerNotInShopify: 'Ta stranka še ne obstaja v Shopify.',
    warnings: 'Opozorila:',
    createCustomerAndPush: 'Ali želite ustvariti stranko v Shopify in poslati osnutek naročila?',
    downloadTitle: 'Prenesi osnutke',
    cancel: 'Prekliči',
  },
  draftEdit: {
    number: "Stevilka",
    prefix: "Predpona",

    newDraft: 'Nov osnutek',
    editDraft: 'Uredi osnutek',
    viewInShopify: 'Ogled v Shopify',
    back: 'Nazaj',
    createDraft: 'Ustvari osnutek',
    saveChanges: 'Shrani spremembe',
    documentType: 'Vrsta dokumenta',
    draftOrder: 'Osnutek naročila',
    quote: 'Ponudba',
    proforma: 'Predračun',
    manualInvoice: 'Ročni račun',
    currency: 'Valuta',
    expiryDate: 'Datum veljavnosti',
    status: 'Status',
    draft: 'Osnutek',
    sent: 'Poslano',
    accepted: 'Sprejeto',
    customer: 'Stranka',
    firstName: 'Ime',
    lastName: 'Priimek',
    email: 'E-pošta',
    phone: 'Telefon',
    company: 'Podjetje',
    taxId: 'Davčna številka',
    billingAddress: 'Naslov za račun',
    address: 'Naslov',
    aptSuite: 'Stanovanje/Apartma',
    city: 'Mesto',
    province: 'Pokrajina',
    countryField: 'Država',
    zip: 'Poštna številka',
    shippingAddress: 'Naslov za dostavo',
    sameAsBilling: 'Enako kot naslov za račun',
    lineItems: 'Postavke',
    shipping: 'Dostava',
    shippingTitle: 'Naziv',
    shippingPlaceholder: 'npr. Standardna dostava',
    price: 'Cena',
    note: 'Opomba',
    notePlaceholder: 'Interna opomba ali sporočilo stranki...',
    summary: 'Povzetek',
    subtotal: 'Vmesni seštevek',
    discounts: 'Popusti',
    tax: 'Davek',
    total: 'Skupaj',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Vnesite naslov vaše trgovine',
    loginWith: 'Prijavite se z',
    createAccount: 'Ustvarite nov račun',
    placeholder: 'ime-vaše-trgovine',
    shopRequired: 'Ime trgovine je obvezno',
    login: 'Prijava',
    shopify: 'Shopify',
    terms: 'Pogoji uporabe',
    privacy: 'Politika zasebnosti',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Vam je Invoice Browse všeč?',
    description: 'Ustvarili ste svoje prve račune! Če se vam zdi aplikacija uporabna, nam hitra ocena v Shopify App Store zelo pomaga.',
    reward: 'V zahvalo vam bomo ponastavili mesečni števec uporabe na 0',
    leaveReview: 'Pustite oceno',
    maybeLater: 'Morda pozneje',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Dobrodošli v Invoice Browse',
    welcomeContent: 'Dovolite, da vam pokažem, kako ga lahko uporabljate.',
    dashboardTitle: 'Nadzorna plošča',
    dashboardContent: 'Zaslon, ki ga vidite, je glavna nadzorna plošča. Tukaj najdete vsa naročila in jih lahko izvozite v različne vrste dokumentov, kot so: računi, dobavnice in drugo.',
    automationTitle: 'Olajšajte si življenje',
    automationContent: 'Omogočite avtomatizacijo za ustvarjanje računov, kadarkoli so naročila plačana ali vrnjena.',
    templatesTitle: 'Prilagodite predloge',
    templatesContent: 'Vstopite sem, da prevedete svojo predlogo, jo prilagodite ali ustvarite novo.',
    deliveryTitle: 'Dostava',
    deliveryContent: 'Nastavite našo aplikacijo za samodejno kopiranje ustvarjenih dokumentov na FTP, Google Drive ali kot priloge za e-pošto.',
    settingsTitle: 'Nastavitve',
    settingsContent1: 'Prilagodite telefonsko številko podjetja, e-pošto in druga polja, ki se uporabljajo na dokumentih.',
    settingsContent2: 'Spremenite začetno številko dokumenta ali izbrišite dokumente, ustvarjene po določenem datumu.',
    settingsContent3: 'Preglasite stopnje DDV za dostavo in izdelke',
    settingsContent4: 'Spremenite decimalna mesta za številke',
    reviewTitle: 'Napišite oceno',
    reviewContent: 'Podprite našo ekipo z dobro oceno!',
    tourTitle: 'Uvodni ogled',
    tourContent: 'Hej, ta ogled lahko znova odprete od tukaj.',
    createDocTitle: 'Ustvarite svoj prvi dokument',
    createDocContent: 'Kliknite gumb Ustvari, da ustvarite svoj prvi dokument.',
    docNumberTitle: 'Številka dokumenta',
    docNumberContent: 'Prvemu dokumentu je dodeljena številka 1. Če želite začeti z drugo številko, jo lahko spremenite v Nastavitvah.',
    downloadDocTitle: 'Prenesite dokument',
    downloadDocContent: 'Kliknite na spustni meni Prenesi in izberite predlogo dokumenta za izvoz naročila kot PDF.',
  },
  common: {
    save: 'Shrani',
    cancel: 'Prekliči',
    close: 'Zapri',
    discard: 'Zavrzi',
    delete: 'Izbriši',
    edit: 'Uredi',
    create: 'Ustvari',
    loading: 'Nalaganje...',
    unsavedChanges: 'Neshranjene spremembe',
    upgradePlan: 'Nadgradite svoj paket',
  },
  languageSelector: {
    label: 'Jezik',
    auto: 'Samodejna zaznava',
  },
  draftList: {
    draftNum: 'Osnutek #',
    shopifyId: 'Shopify ID',
    type: 'Tip',
    customer: 'Stranka',
    total: 'Skupaj',
    status: 'Status',
    delivered: 'Dostavljeno',
    date: 'Datum',
    actions: 'Dejanja',
    noCustomer: 'Brez stranke',
    noDrafts: 'Ni najdenih osnutkov ali ponudb.',
    loading: 'Nalaganje...',
    download: 'Prenesi',
    default: 'Privzeto',
    pending: 'V čakanju',
    deliverNow: 'Dostavi zdaj',
    deliveryDetails: 'Podrobnosti dostave',
    sent: 'Poslano',
    failed: 'Neuspešno',
    deliverAgain: 'Dostavi ponovno',
    partial: 'Delno',
    notDelivered: 'Ni dostavljeno',
    deliveryFailed: 'Dostava neuspešna',
    unknown: 'Neznano',
    edit: 'Uredi',
    send: 'Pošlji',
    pushToShopify: 'Pošlji v Shopify',
    complete: 'Zaključi',
    duplicate: 'Podvoji',
    delete: 'Izbriši',
    quote: 'Ponudba',
    proforma: 'Proforma',
    draftOrder: 'Osnutek naročila',
    manualInvoice: 'Ročni račun',
  },
  draftSearch: {
    createdBtw: 'Ustvarjeno med',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Stranka',
    status: 'Status',
    type: 'Tip',
    delivery: 'Dostava',
    any: 'Vse',
    draft: 'Osnutek',
    sent: 'Poslano',
    accepted: 'Sprejeto',
    expired: 'Poteklo',
    converted: 'Pretvorjeno',
    cancelled: 'Preklicano',
    quote: 'Ponudba',
    proforma: 'Proforma',
    draftOrder: 'Osnutek naročila',
    manualInvoice: 'Ročni račun',
    delivered: 'Dostavljeno',
    notDelivered: 'Ni dostavljeno',
    pending: 'V čakanju',
    search: 'Iskanje',
  },
  draftDownload: {
    title: 'Prenesi Osnutek #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Tip',
    any: 'Vse',
    draft: 'Osnutek',
    sent: 'Poslano',
    accepted: 'Sprejeto',
    expired: 'Poteklo',
    converted: 'Pretvorjeno',
    cancelled: 'Preklicano',
    quote: 'Ponudba',
    proforma: 'Proforma',
    draftOrder: 'Osnutek naročila',
    manualInvoice: 'Ročni račun',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Namesti novo predlogo',
    tabStyle: 'Slog',
    tabContent: 'Vsebina',
    tabTranslations: 'Prevodi',
    tabSettings: 'Nastavitve',
    tabCode: 'Koda',
    tabCopilot: 'AI Kopilot',
    logo: 'Logotip',
    colorPalette: 'Barvna paleta',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/sl.js